import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.sub.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default {
  __name: 'index',
  setup: function setup(__props) {
    var pagemain = computed(function () {
      var route = useRoute();
      var folder = route.params.root || 'home';
      folder = folder.toLowerCase();
      var filename = route.params.sub || folder;
      if (folder == 'course' || folder == 'uwe') {
        filename = folder;
      }
      return defineAsyncComponent(function () {
        return import('@/views/' + folder + '/' + filename + ".vue");
      });
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(_resolveDynamicComponent(_unref(pagemain)), _toHandlers(_ctx.$attrs), null, 16);
    };
  }
};